import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import BookingDetail from "../bookingdeatil/bookingDetail"
import FareDetail from "../faredetail/fareDetail";
import KeepInMind from "../keepinmind/keepInMindContent";

const carCheckoutContent = () => {
  return (
    <section className="car-checkout-content pt-4 pb-4">
      <Container>
        <Row>
          <Col lg={8}>
            {" "}
            <div className="verification-wrap">
                <Row>
                    <Col md={12}><BookingDetail /></Col>
                </Row>

                <Row>
                    <Col md={12}><KeepInMind /></Col>
                </Row>
            </div>
          </Col>
          <Col lg={4}>
            <div className="verification-wrap">
              <FareDetail />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default carCheckoutContent;
